var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIconDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.316,
    height: 23.123,
    viewBox: "0 0 21.316 23.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#47474a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.606,17.882h0A.532.532,0,0,0,18.76,18a.289.289,0,0,0,.193.039h0a.471.471,0,0,0,.347-.154h0l6.475-6.475h0a.463.463,0,0,0-.655-.655l-5.7,5.7V.462a.462.462,0,0,0-.925,0V16.456l-5.665-5.7a.463.463,0,1,0-.655.655Z",
    transform: "translate(-8.277)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.188,44.7a.445.445,0,0,0-.462.462v4.509H3.225V45.162a.445.445,0,0,0-.462-.462.445.445,0,0,0-.462.462v4.972a.445.445,0,0,0,.462.462H23.15a.445.445,0,0,0,.462-.462V45.162A.416.416,0,0,0,23.188,44.7Z",
    transform: "translate(-2.3 -27.473)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconDark);
export default __webpack_public_path__ + "static/media/download-icon-dark.f31e548da366aad4f451908ea3c04028.svg";
export { ForwardRef as ReactComponent };